import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next'


const Cta1 = ({ title, subtitle }) => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: ''
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        navigate('/account');
    };

    return (
        <div className='cta1-content'>
            <div 
                className='cta1-image'
                style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/assets/images/new-img/yeni-cta.jpg)` }}
            ></div>
            <div className="container">
                <div className='row align-items-center'>
                    <div className="col-lg-6">
                        <div className='cta1-left-content'>
                            <h2 className='cta1-main-title'>{title || t('cta1.mainTitle')}</h2>
                            <p className='cta1-description'>
                                {subtitle || t('cta1.description')}
                            </p>
                            <Link to="/account">
                                <button className="cta1-donate-btn">{t('cta1.donateNow')}</button>
                            </Link>
                        </div>
                    </div>
                    {/* <div className="col-lg-6 cta-form-box">
                        <div className='cta1-newsletter-box'>
                            <h3 className='cta1-newsletter-title'>{t('cta1.newsletterTitle')}</h3>
                            <p className='cta1-newsletter-subtitle'>
                                {t('cta1.newsletterSubtitle')}
                            </p>
                            <form onSubmit={handleSubmit}>
                                <div className='row'>
                                    <div className='col-md-6 mb-3'>
                                        <input
                                            type="text"
                                            name="firstName"
                                            className='cta1-input'
                                            placeholder={t('cta1.firstName')}
                                            value={formData.firstName}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </div>
                                    <div className='col-md-6 mb-3'>
                                        <input
                                            type="text"
                                            name="lastName"
                                            className='cta1-input'
                                            placeholder={t('cta1.lastName')}
                                            value={formData.lastName}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </div>
                                </div>
                                <div className='mb-3'>
                                    <input
                                        type="email"
                                        name="email"
                                        className='cta1-input'
                                        placeholder={t('cta1.email')}
                                        value={formData.email}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </div>
                                <p className='cta1-required-text'>* {t('cta1.allFieldsRequired')}</p>
                                <button type="submit" className='cta1-subscribe-btn'>
                                    {t('cta1.subscribe')}
                                </button>
                            </form>
                        </div>
                    </div> */}
                </div>
            </div>
        </div>
    )
}

export default Cta1